import type { PluginOption } from 'vite';

/*
  This is needed because @wix/design-system is using `draft-js`,
  which is wrongfully using `global` for accessing a `setImmediate` polyfill which they provide.
  Moreover, `draft-js` has been deprecated and is no longer maintained.
  Probably never going to get fixed:
  - https://github.com/facebookarchive/draft-js/issues/2127
  - https://github.com/facebook/fbjs/issues/290
*/
const define = { global: 'window' } as const;

export function draftJs(): PluginOption {
  return [
    {
      name: 'fix-draft-js',
      apply: 'serve',
      config: () => ({ optimizeDeps: { esbuildOptions: { define } } }),
    },
    {
      name: 'fix-draft-js',
      apply: 'build',
      config: () => ({ esbuild: { define } }),
    },
  ];
}
